// This component renders a link styled as a button
// Should be used to havigate to different routes in the application

import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import classNames from 'classnames';

import './ButtonLink.scss';

export const ButtonLink = ({ route, text, hasActiveState = true }) => {
    const { pathname } = useLocation();
    const classes = classNames('button-link', {
        'button-link-active': pathname === route && hasActiveState,
    });

    return (
        <Link to={route} className={classes}>
            {text}
        </Link>
    );
};
